module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('TableView', {
    attrs: {
      "onSearch": _vm.getConsultaExame,
      "tableData": _vm.tableData,
      "tableHead": _vm.tableHead,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "loadingTable": _vm.loadingTable,
      "disableInputSearch": "",
      "disableCheckAll": "",
      "disabledConfigCell": ""
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-424fca20"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/empresa/consulta/exames/index.vue
// module id = 1457
// module chunks = 45